export const assetItems = [
    {
        displayValue: "Please Select",
        value: " ",
        limit: 1
    },
    {
        displayValue: "Residential Property (Primary residence) you permanently live in and is owned by yourself",
        value: "primary_residential",
        limit: 1
    }, {
        displayValue: "Other residential property",
        value: "other_residential"
    }, {
        displayValue: "Farm/s owned by you",
        value: "farms_owned"
    }, {
        displayValue: "Motor Vehicles",
        value: "motorvehicles"
    }, {
        displayValue: "Household content (not replacement value)",
        value: "household_content"
    }, {
        displayValue: "Fire arms",
        value: "firearms"
    }, {
        displayValue: "Aeroplanes",
        value: "aeroplanes"
    }, {
        displayValue: "Boats",
        value: "boats"
    }, {
        displayValue: "Trailers",
        value: "trailers"
    }, {
        displayValue: "Caravans",
        value: "caravans"
    }, {
        displayValue: "Motor bikes",
        value: "motorbikes"
    }, {
        displayValue: "Shares listed on the JSE",
        value: "jse_shares"
    }, {
        displayValue: "Investments",
        value: "investments"
    }, {
        displayValue: "Cash in bank or fixed deposits",
        value: "cash_in_bank_or_fixed_deposits"
    }, {
        displayValue: "Interest in Partnership",
        value: "interest_in_partnership"
    }, {
        displayValue: "Interest in Close Corporation",
        value: "interest_in_close_corporation"
    }, {
        displayValue: "Shareholding in a Private Company (not listed)",
        value: "shareholding_in_private_company"
    }, {
        displayValue: "Loan amount owed to you by Trusts",
        value: "loan_amount_owed_to_you_by_trusts"
    }, {
        displayValue: "Loan amount owed to you by Closed Corporations",
        value: "loan_amount_owed_to_you_by_closed_corporations"
    }, {
        displayValue: "Loan amount owed to you by Private Companies",
        value: "loan_amount_owed_to_you_by_private_companies"
    }, {
        displayValue: "Foreign Assets",
        value: "foreign_assets"
    }, {
        displayValue: "Usufruct, Annuity charged on Property or similar right",
        value: "usufruct_annuity_charged_on_property_or_similar_right"
    },

];


// WEBPACK FOOTER //
// ./src/views/Fna/steps/objects/assetItems.js